var map = {
	"./bell.svg": 3516,
	"./bitcoin.svg": 6163,
	"./btc.svg": 396,
	"./buy_icon.svg": 9139,
	"./closeBanner.svg": 5747,
	"./competitions.svg": 9135,
	"./ethereum.svg": 1343,
	"./galka.svg": 2085,
	"./kz.svg": 1420,
	"./lose.svg": 1068,
	"./ru.svg": 8372,
	"./sbp.svg": 6052,
	"./sell_icon.svg": 509,
	"./settings.svg": 716,
	"./testBTC.svg": 5668,
	"./testUSDT.svg": 4671,
	"./tether.svg": 495,
	"./ua.svg": 7589,
	"./usa.svg": 9668,
	"./usd.svg": 441,
	"./win.svg": 4295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;